/**
 * @file 封装 HTTP 相关请求
 * @author qiaogang
 * @date 2019-08-30
 */

import { httpRequest } from '@igetcool/base-components';

export default httpRequest;
